"use client";

import CheckIfTrial from "@/components/CheckIfTrial";
import ClassView from "@/components/ClassView";

const classPage = () => {
  return (
    <CheckIfTrial>
      <ClassView />
    </CheckIfTrial>
  );
};

export default classPage;
